import { TradeActions, TradeStateType } from './tradeTypes';

const tradeReducer = (state: TradeStateType, action: TradeActions): TradeStateType => {
    switch (action.type) {
        case 'TOGGLE_IS_SHORT':
            return {
                ...state,
                isShort: !state.isShort,
            };
        case 'SET_TRADE_TYPE':
            return {
                ...state,
                tradeType: action.payload,
                limitPrice: '',
            };
        case 'SET_LEVERAGE':
            return {
                ...state,
                leverage: action.payload,
            };
        case 'SET_COLLATERAL':
            return {
                ...state,
                collateral: action.payload,
            };
        case 'SET_LIMIT_PRICE':
            return {
                ...state,
                limitPrice: action.payload,
            };
        default:
            return state;
    }
};

export default tradeReducer;
